import { MediaItemCardLCSubItem } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardLocalCombination/MediaItemCardLCSubItem/MediaItemCardLCSubItem";
import {
  Article,
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import SimpleArticleCardSkeleton from "@coworker/apprestructured/src/shared/simple/SimpleSkeleton/SimpleArticleCardSkeleton";
import React from "react";
import styles from "./local-combinations-items-list-view-item.module.css";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";

interface LocalCombinationsItemsListViewItemProps {
  itemNo: string;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  article: Article;
  totalQuantityPieces: number;
  mediaItemViewType?: MediaItemViewType;
}

export const LocalCombinationsItemsListViewItem = ({
  itemNo,
  edsData,
  salesStopData,
  article,
  totalQuantityPieces,
  mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
}: LocalCombinationsItemsListViewItemProps) => {
  const { data: itemInfo, isLoading } = useItemInfo(itemNo);
  return (
    <div className={styles["lc-items-list-view-item"]}>
      {isLoading && <SimpleArticleCardSkeleton />}
      {!isLoading && itemInfo && (
        <MediaItemCardLCSubItem
          itemCardRenderType={ItemCardRenderType.link}
          edsData={edsData}
          salesStopData={salesStopData}
          itemInfo={itemInfo}
          article={article}
          totalQuantityPieces={totalQuantityPieces}
          mediaItemViewType={mediaItemViewType}
        />
      )}
    </div>
  );
};
